import React from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Box } from '@mui/material';
import { PowerRankingRowData } from './types';

interface OverviewTabProps {
  data: PowerRankingRowData[];
}

export function OverviewTab({ data }: OverviewTabProps) {
  const overviewColumns: MRT_ColumnDef<PowerRankingRowData>[] = [
    {
      accessorKey: 'teamName',
      header: 'Team',
      size: 150,
      enableHiding: false,
    },
    {
      accessorKey: 'powerPoints',
      header: '"Power Score"',
      size: 100,
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number}</Box>
      ),
    },
    {
      accessorKey: 'powerRank',
      header: 'Power Rank',
      size: 100,
      Cell: ({ cell }) => (
        <Box><b>#{cell.getValue() as number}</b></Box>
      ),
    },
    {
      accessorKey: 'winPctg',
      header: 'Win %',
      size: 100,
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number !== undefined ? (Math.round(cell.getValue() as number * 1000) / 10) + "%" : '-'}</Box>
      ),
    },
    {
      accessorKey: 'totalPoints',
      header: 'Points',
      size: 100,
      Cell: ({ cell }) => (
        <Box>{Math.round(cell.getValue() as number)}</Box>
      ),
    },
    {
      accessorKey: 'totalOptimalPoints',
      header: 'Optimal Points',
      size: 120,
      Cell: ({ cell }) => (
        <Box>{Math.round(cell.getValue() as number)}</Box>
      ),
    },
    {
      accessorKey: 'optimalPointsDiffPctg',
      header: 'Coaching Efficiency',
      size: 120,
      Cell: ({ cell }) => (
        <Box>{cell.getValue() as number !== undefined ? (100 - Math.round(cell.getValue() as number * 1000) / 10) + "%" : '-'}</Box>
      ),
    },
  ];

  return (
    <MaterialReactTable 
      columns={overviewColumns} 
      data={data} 
      enableColumnActions={false}
      enablePagination={false}
      initialState={{
        sorting: [
          {
            id: 'powerRank',
            desc: false,
          },
        ],
        density: 'compact',
      }}
    />
  );
}
